import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface FundAllocationData {
  id: string;
  category: string;
  amount: number;
  percentage: number;
  description: string;
  color: string;
  created_at: string;
  breakdown_items: {
    item: string;
    allocation: number;
  }[];
}

export const useFundAllocation = () => {
  return useQuery({
    queryKey: ['fundAllocation'],
    queryFn: async () => {
      const { data: allocations, error: allocationsError } = await supabase
        .from('fund_allocation')
        .select(`
          *,
          fund_breakdown_items (
            item,
            allocation
          )
        `)
        .order('amount', { ascending: false });
      
      if (allocationsError) throw allocationsError;

      return (allocations || []).map(allocation => ({
        ...allocation,
        breakdown_items: allocation.fund_breakdown_items || []
      })) as FundAllocationData[];
    },
  });
};